import { render, staticRenderFns } from "./MedsSeparate.vue?vue&type=template&id=23ac93b6"
import script from "./MedsSeparate.vue?vue&type=script&lang=js"
export * from "./MedsSeparate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports